import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { thunk } from 'redux-thunk';
import authReducer from './slices/authSlice';
import contestReducer from './slices/contestSlice';
import guessReducer from './slices/guessSlice';
import dailyPhotoReducer from './slices/dailyPhotoSlice';
import triviaReducer from './slices/triviaSlice';
import cruiseReducer from './slices/cruiseSlice';
import cruiseDetailsReducer from './slices/cruiseDetails';
import shipDetailsReducer from './slices/shipDetails';
import leaderboardReducer from './slices/leaderboardSlice';
import entriesReducer from './slices/entriesSlice';

const CURRENT_STORE_VERSION = '1.0.0';

const persistConfig = {
  key: 'CruiseContest',
  storage,
  version: CURRENT_STORE_VERSION,
  migrate: (state) => {
    if (state && state._persist && state._persist.version !== CURRENT_STORE_VERSION) {
      storage.removeItem('persist:CruiseContest');
      return Promise.resolve({});
    }
    return Promise.resolve(state);
  },
};

const rootReducer = combineReducers({
  auth: authReducer,
  contest: contestReducer,
  guess: guessReducer,
  dailyPhoto: dailyPhotoReducer,
  trivia: triviaReducer,
  cruises: cruiseReducer,
  cruiseDetails: cruiseDetailsReducer,
  shipDetails: shipDetailsReducer,
  leaderboard: leaderboardReducer,
  entries: entriesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(thunk),
});

const persistor = persistStore(store);

export { store, persistor };